<template>
  <div class="batch-add-container" :style="{ padding: batchAddStyle === 'table' ? '0 12px' : '' }">
    <template v-if="Object.keys(config).length === 0">
      <div class="no-config"></div>
    </template>
    <template v-else>
      <template v-if="batchAddStyle === 'table'">
        <batch-tables :queryData="queryData" :property="property" :customData="customData" v-if="config.tableConfig && Object.keys(config.tableConfig.web).length > 0" :isConfig="false" ref="batchTables" :config="config.tableConfig.web" :appInfo="appInfo" />
      </template>
      <template v-else>
        <select-table :queryData="queryData" :property="property" :customData="customData" @changeActiveCol="changeActiveCol" v-if="config.selectConfig && Object.keys(config.selectConfig.web).length > 0" :activeColInfo="activeColInfo" :activeColId="activeColId" :isConfig="false" ref="selectTbale" :config="config.selectConfig.web" :appInfo="appInfo" />
      </template>
    </template>
  </div>
</template>

<script>
import batchTables from '@/components/admins/workBench/moreSetting/mycomponent/batchAddition/tableSet/batchTables.vue'
import selectTable from '@/components/admins/workBench/moreSetting/mycomponent/batchAddition/selectSet/selectTable.vue'
import { momVal } from '@/api/utils'
import { cloneDeep } from 'lodash';
export default {
  // 组件名称
  name: 'batchAdd',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    batchAddStyle: {
      type: String,
      default: 'table'
    },
    appInfo: {
      type: Object,
      default: () => ({})
    },
    queryData:{
      type: Object,
      default: () => ({})
    },
    customData: {
      type: Array,
      default: () => []
    },
    property: {
      type: Array,
      default: () => []
    },
    animationStyle: {
      type: Object,
      default: () => {}
    },
  },
  // 局部注册的组件
  components: {
    batchTables,
    selectTable
  },
  // 组件状态值
  data() {
    return {
      activeColInfo: {},
      activeColId: 1,
      formdata: {}
    }
  },
  // 计算属性
  computed: {
    getSubmitMsg() {
      const COMMON_TEXT = '新增成功'
      if(this.animationStyle) {
        const config = this.animationStyle
        if(Object.keys(config).length === 0) return COMMON_TEXT
        const value = config.value
        const text = config.animationList[value]
        if(text) {
          return text.text
        }
        else return COMMON_TEXT
      } else {
        return COMMON_TEXT
      }
    }
  },
  // 组件方法
  methods: {
    changeActiveCol(item) {
      this.activeColId = item.id
      this.activeColInfo = item
    },
    async submit() {
      if (this.batchAddStyle === 'table') {
        await this.$refs.batchTables.submit(this.formdata, this.getSubmitMsg)
        this.$refs.batchTables.clearTable()
      } else {
        await this.$refs.selectTbale.submit(this.formdata, this.getSubmitMsg)
        this.$refs.selectTbale.clearTable()
      }
    },
    getConfig() {
      const config = this.config.selectConfig
      if (this.batchAddStyle === 'select' && config.web) {
        this.activeColId = config.web.colList[0].id
        this.activeColInfo = config.web.colList[0]
      }
    }
  },
  watch: {
    'config.selectConfig': {
      handler(config) {
        if (this.batchAddStyle === 'select' && config.web) {
          this.activeColId = config.web.colList[0].id
          this.activeColInfo = config.web.colList[0]
        }
      },
      immediate: true
    },
    property: {
      handler(val) {
        let formdata = momVal(val, '', this.customData)
        const date = cloneDeep(formdata)
        for (const key in date) {
          if (!date[key]) {
            delete formdata[key]
          } else if (date[key] && Array.isArray(date[key]) && date[key].length === 0) {
            delete formdata[key]
          } else if (date[key] && typeof date[key] === 'object' && Object.keys(date[key]).length === 0) {
            delete formdata[key]
          }
        }
        const obs = {}
        for (const key in formdata) {
          const [title] = key.split('_')
          const item = val.find(item => item.title === title)
          if (item) {
            obs[`${key}_${item.name}`] = formdata[key]
          }
        }
        this.formdata = obs
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.batch-add-container {
  flex: 1;
  height: calc(100% - 60px);
  box-sizing: border-box;
}
</style>
